import { AppPermission, PermissionKey } from 'shared/types';

export const PERMISSIONS: Record<PermissionKey, AppPermission> = {
    login: 'paragon.login',

    admin: 'paragon.admin',
    'customer-sales-rep': 'paragon.customer-sales-rep',

    'add-product': 'paragon.add-product',
    'approve-customer-tier-override': 'paragon.approve-customer-tier-override',
    'approve-deviation': 'paragon.approve-deviation',
    'approve-market-price': 'paragon.approve-market-price',
    'mass-edit-market-prices': 'paragon.mass-edit-market-prices',
    'mass-edit-deviations': 'paragon.mass-edit-deviations',
    'page-active-price-management': 'paragon.page-active-price-management',
    'page-active-price-management.read': 'paragon.page-active-price-management.read',
    'page-future-price-management.read': 'paragon.page-future-price-management.read',
    'page-product-management': 'paragon.page-product-management',
    'page-settings': 'paragon.page-settings',
    'view-all-distributors': 'paragon.view-all-distributors',
    'expire-market-price': 'paragon.expire-market-price',
};
